import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select');
const crypto = require('crypto')
const moment = require('moment');

var emptyOptInSMSRecord = {
	smsNumber: '',
	optIn: false,
	lastUpdated: ''
}

class OptInSMS extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			showBox: false,
			loading: false,
			filterBy: {}
		};
	}

	checkState = (option) => {
		console.log('state')
		console.log(this.state)
	}

	showEditBox = (type, data) => e => {
		console.log('showEditBox');
		console.log(data);

		this.setState({
			showBox: type,
			selectedObject: data,
			loading: false
		})
		console.log(this.state);
	}

	showAddBox = (type) => e => {
		console.log('showAddBox');
		var data = emptyOptInSMSRecord

		this.setState({
			showBox: type,
			setting: {},
			loading: false,
			selectedObject: data,
		})
	}

	showDeleteBox = (type, data) => e => {
		console.log('showDeleteBox')
		e.stopPropagation()
		this.setState({ showBox: type, selectedObject: data, loading: false })
	}

	editParam = (param) => (e) => {
		console.log('editParam')

		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = e.target.value
		console.log('newSetting');
		console.log(newSetting);
		this.setState({ selectedObject: newSetting, loading: false })
		
		console.log(this.state);
	}
	editOptInMessage = () => (e) => {
		console.log('editOptInMessage')

		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting.sms.body.English = e.target.value
		this.setState({ selectedObject: newSetting, loading: false })
		
		console.log(this.state);
	}

	toggle = (param) => (e) => {
		console.log('toggle')
		console.log(this.state.selectedObject);

		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = this.state.selectedObject[param] ? false : true
		this.setState({ selectedObject: newSetting, loading: false })
	}

	cancel = () => {
		console.log('cancel');
		this.setState({
			showBox: false,
			addingSetting: false,
			loading: false,
			selectedObject: false,
			error: false,
		})

		console.log(this.state);
	}

	toggleSection = (option) => {
		if (option) {
			this.setState({ selectedSection: option.id, error: '' });
		}
	}

	confirmAdd = (data) => (e) => {
		console.log('confirmAdd');

		if (data.smsNumber.length < 10 || data.smsNumber.length > 10 || isNaN(data.smsNumber)) {
			this.setState({error: 'Please enter a valid 10-digit phone number for SMS.'});
		} else {
			//set lastUpdated to current time
			data.lastUpdated = new Date().getTime();
			this.props.ws.send(JSON.stringify({ route: 'addOptInSMS', setting: data }));
		}

        this.cancel();
	}

	confirmEdit = (data) => (e) => {
		console.log('confirmEdit');

		data.lastUpdated = new Date().getTime();

		this.props.ws.send(JSON.stringify({ route: 'editOptInSMS', setting: data }));
        this.cancel();
	}

	confirmSettings = (data) => (e) => {
		if (data.sms.body.English.length > 160) {
			this.setState({error: 'Please limit message to 160 characters or fewer.'});
		} else {
			console.log('data');
			console.log(data);
			this.props.ws.send(JSON.stringify({ route: 'editOptInSettings', setting: data }))
		}
		this.cancel();
	}

	confirmDelete = (type, data) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'delete' + type, setting: data }))
	}
	
	filter = (newFilter) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[newFilter] = e.target.value
		} else {
			delete filterBy[newFilter]
		}
		this.setState({ filterBy: filterBy }) //
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === 'dateRange') {
				return new Date(a.StartDateTime).getTime() > new Date(b.StartDateTime).getTime() ? 1 * sortOrder : -1 * sortOrder
			}
			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
			} else {

				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (prop === 'records') {
					if (object.rows.length.toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				} else if (prop === 'updatedDate') {
					if ((new Date(object.updatedDate).toDateString().substring(4) + ', ' + new Date(object.updatedDate).toLocaleTimeString()).toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				} else if (typeof object[prop] === "undefined") {
					return false
				} else if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}

	newID() {
        var hexstring = crypto.randomBytes(10).toString("hex");
        return [hexstring.substring(0, 19), new Date().getTime().toString()].join('');
    }

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}

	render() {
		if (this.props.active) {
			var contentMain, contentEditBox

			contentMain = [];
			contentEditBox = [];
			contentMain.push(<img src={this.props.img.plus} className="plusButton" alt="Add An Opt-In Record" onClick={this.showAddBox('add')} />);
            contentMain.push(<img src={this.props.img.gear} className="plusButton2" alt="Settings" onClick={this.showEditBox('settings', this.props.data.OptInSMS.optInTemplate)} />);


			contentMain.push(
				<div>
					<div className="dataHeaders">
						<span style={{ flex: '2 2 25%', cursor: 'pointer' }}>SMS Number</span>
						<span style={{ flex: '2 2 30%', cursor: 'pointer' }}>Opt In Status</span>
						<span style={{ flex: '2 2 30%', cursor: 'pointer' }}>Last Updated</span>
					</div>
					<div className="dataFilters">
						<input style={{ maxWidth: '200px', flex: '1 1 10%' }} type="text" onChange={this.filter("smsNumber")} value={this.state.filterBy.smsNumber} />
					</div>
				</div>
			)

			var list = []

			//convert object to array for sort/filter features
			console.log(this.props.data.OptInSMS)
			for (let i in this.props.data.OptInSMS.smsNumbers) {
				let item = this.props.data.OptInSMS.smsNumbers[i]
				list.push(item)
			}

			list =  list.slice();
			list.sort(this.sortFunc('smsNumber', 1))


			if (Object.keys(this.state.filterBy).length > 0) {
				list = this.filterFunc(list.slice(), this.state.filterBy)
			}

			if (this.state.sortBy !== '') {
				list.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			for (let i in list) {
				var item = list[i]
				contentMain.push(
					<div className="dataRow" key={item.smsNumber} onClick={this.showEditBox('edit', item)}>
						<span style={{ flex: '0 0 30%', textAlign: 'left'}}>{item.smsNumber}</span>
						<span style={{ flex: '1 0 30%', textAlign: 'left'}}>
                            <div className="activeBox">
                                <div className={item.optIn ? "enabled" : "disabled"}></div>
                            </div>
                        </span>						
						<span style={{ flex: '1 0 30%', textAlign: 'left'}}>{item.lastUpdated ? moment(item.lastUpdated).format('YYYY-MM-DD hh:mm:ss a') : ''}</span>
					</div>
				)
			}

			if (this.state.showBox === 'edit') {
				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are editing Opt In status for: {this.state.selectedObject.smsNumber}</div>

							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>Opt In?</div>
									<div className="activeBox" onClick={this.toggle('optIn')}>
										<div className={this.state.selectedObject.optIn ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<br /><br />

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmEdit(this.state.selectedObject)} >Confirm</div>}

						</div>
					</div>
				)
			} else if (this.state.showBox === 'add') {
				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are adding a new Opt In record</div>

							<br/>

							<div style={{ display: 'flex' }}>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.smsNumber} onChange={this.editParam('smsNumber')} ></input>
									<span className="inputBar"></span><label className="textLabel">SMS Number</label>
								</div>
							</div>

							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>Opt In?</div>
									<div className="activeBox" onClick={this.toggle('optIn')}>
										<div className={this.state.selectedObject.optIn ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<br /><br />

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmAdd(this.state.selectedObject)} >Confirm</div>}

						</div>
					</div>
				)
			} else if (this.state.showBox === 'delete') {
				/*
				contentEditBox.push (
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>
							<div style={{ textAlign: 'center' }}>You are removing this recipient:</div>
							<div style={{ textAlign: 'center' }}>{this.state.selectedObject.firstName} {this.state.selectedObject.lastName}</div>
							<br />

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete('GTFSRecipient', this.state.selectedObject)}>Delete Recipient</div>}
						</div>
					</div>
				)
				*/
			} else if (this.state.showBox === 'settings') {
				console.log('this.state.selectedObject');
				console.log(this.state.selectedObject);
				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>SMS Opt In Settings</div>

							<br/>

							<div className="snazzyInputBox">
									<textarea className="bigTextInput" required value={this.state.selectedObject.sms.body.English} onChange={this.editOptInMessage()} ></textarea>
									<label className="textLabel">SMS Opt In Request Message</label>
									<div style={{ color: this.state.selectedObject.sms.body.English.length > 160 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.sms.body.English.length}/160</div>
								</div>

							<br /><br />

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmSettings(this.state.selectedObject)} >Confirm</div>}

						</div>
					</div>
				)
			}
			
			return (
				<div className="viewContent" id="reportView" >
					<div style={{ overflow: 'auto', height: 'calc(100% - 45px)' }}>
						{contentMain}
					</div>
					{contentEditBox}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuHelp"
const roles = ["View"]
export { OptInSMS, icon, roles }